import { Entity, EntityConfiguration, Schema } from '@technocom/data/core';
import {
  COMPANY_KPP_MASK,
  COMPANY_KPP_REGEX,
  COMPANY_KPP_REGEX_HELP,
  EMAIL_REGEX,
  EMAIL_REGEX_HELP,
  INN_MASK,
  INN_REGEX,
  INN_REGEX_HELP,
} from '../util/validators';

/**
 * Организация.
 */
export class Organization extends Entity<OrganizationDTO, number> {
  static readonly options: EntityConfiguration = Entity.extendOptions({
    namespace: 'org',
    title: 'Организация',
    serverUrl: '/organization-controller/organization',
    enableFormGroups: true,
  });

  static readonly schema: Schema = Entity.extend<OrganizationDTO>({
    text: 'name',
    groups: {
      head: 'Руководитель',
    },
    fields: {
      id: {
        type: Number,
        title: 'ИД',
        options: {
          order: 0,
          column: {
            hidden: false,
          },
        },
      },
      name: {
        type: String,
        title: 'Наименование организации',
        validation: {
          required: true,
          treatBlankAsEmpty: true,
        },
        options: {
          order: 10,
        },
      },
      inn: {
        type: String,
        title: 'ИНН',
        validation: {
          required: true,
          mask: INN_MASK,
          regex: INN_REGEX,
          regexHint: INN_REGEX_HELP,
        },
        options: {
          order: 20,
        },
      },
      kpp: {
        type: String,
        title: 'КПП',
        validation: {
          mask: COMPANY_KPP_MASK,
          regex: COMPANY_KPP_REGEX,
          regexHint: COMPANY_KPP_REGEX_HELP,
        },
        options: {
          order: 30,
          column: {
            width: 125,
          },
        },
      },
      email: {
        type: String,
        title: 'Электронная почта',
        validation: {
          regex: EMAIL_REGEX,
          regexHint: EMAIL_REGEX_HELP,
        },
        options: {
          order: 40,
        },
      },
      phone: {
        type: String,
        title: 'Телефон',
        options: {
          order: 50,
        },
      },
      address: {
        type: String,
        title: 'Адрес',
        options: {
          order: 60,
        },
      },
      addressGuid: {
        type: String,
        title: 'Идентификатор ФИАС',
        serialization: {
          from: 'houseguid',
        },
        options: {
          column: {
            hidden: false,
          },
        },
      },
      website: {
        type: String,
        title: 'Сайт',
        options: {
          order: 70,
        },
      },
      headLastName: {
        type: String,
        title: 'Фамилия',
        group: 'head',
        serialization: {
          from: 'lnameHead',
        },
        options: {
          order: 80,
        },
      },
      headFirstName: {
        type: String,
        title: 'Имя',
        group: 'head',
        serialization: {
          from: 'fnameHead',
        },
        options: {
          order: 90,
        },
      },
      headMiddleName: {
        type: String,
        title: 'Отчество',
        group: 'head',
        serialization: {
          from: 'mnameHead',
        },
        options: {
          order: 100,
        },
      },
      headPosition: {
        type: String,
        title: 'Должность',
        group: 'head',
        serialization: {
          from: 'position',
        },
        options: {
          order: 110,
        },
      },
    },
  });
}

export interface OrganizationDTO {
  id?: number;
  name: string;
  inn: string;
  kpp?: string;
  email?: string;
  phone: string;
  address: string;
  addressGuid?: string;
  website?: string;
  headFirstName?: string;
  headLastName?: string;
  headMiddleName?: string;
  headPosition?: string;
}
